import "./Diary.css";
import moment from "moment";
import React, { useState, useEffect, useRef } from "react";
import DiaryTimeLine from "../../components/diaryTimeline/DiaryTimeline.jsx";
import LoadingSpinner from "../../components/loadSpinner/LoadingSpinner.jsx";
import { Dialog } from "primereact/dialog";
import { deleteTimeCardsRequest, getUserDiaryRequest, updateTimeCardsRequest } from "../../services/wisdomServices/trackingService";
import { getSessionItem } from "../../utils/helper/session";
import { timezones } from "../../utils/helper/timezones";
import { Dropdown } from "primereact/dropdown";
import { getUserTimezoneOffset } from "../../utils/helper/splitUserOffset";
import { userTimezone } from "../../utils/helper/userTimezone";
import {Calendar} from "primereact/calendar"
import {Button} from "primereact/button"
import { FloatLabel } from "primereact/floatlabel";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast'
import SubHeaderLinks from "../../components/subHeaderLinks/SubHeaderLinks.jsx";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useOnboarding } from "../../context/onboardingContext.jsx";
import { Joyride } from "react-joyride";;
import { Can } from "../../security/Can.jsx";
import { PERMISSIONS } from "../../security/permissions.generated.js";

/**
 * @function Diary
 * @returns {JSX.Element} - diary component
 */
function Diary() {
  const today = new Date()
  const { runTour, goToNextPage } = useOnboarding();
  let [selectedDate, setSelectedDate] = useState(today);
  const [visible, setVisible] = useState(false);
  let [summary, setSummary] = useState([]);
  let [loading, setLoading] = useState(false);
  let [loadingImages, setLoadingImages] = useState(true);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedBoxes, setSelectedBoxes] = useState([]);
  const [isManuallySelected, setIsManuallySelected] = useState(false);
  const [offset, setOffset] = useState(getUserTimezoneOffset())
  const [timezone, setTimezone] = useState(userTimezone())
  const [faqVisible, setFaqVisible] = useState(false);
  const toast = useRef(null);

    const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'Operation cancelled', life: 3000 });
    };

  const confirmActivateDialog = () => {
    confirmDialog({
        message: 'Are you sure you want to set these cards as active?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        defaultFocus: 'accept',
        accept: confirmActivateHandler,
        reject
    });
  };

  const confirmDeleteDialog = () => {
    confirmDialog({
        message: 'Are you sure you want to delete these cards?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        defaultFocus: 'accept',
        accept: ConfirmDeleteHandler,
        reject 
    });
  };

  const handleSelectAll = () => {
    setIsManuallySelected(false);
    setSelectAll((prevSelectAll) => !prevSelectAll);
  };


  function ConfirmDeleteHandler() {
    deleteCards();
  }

  async function confirmActivateHandler() {
    await markCardActive();
  }

  let markCardActive = async () => {
    try {
      let checked = document.querySelectorAll("input:checked");
      let num = [];
      for (const item of checked) {
        num.push(parseInt(item.id));
        item.checked = false;
      }
  
      let keys = {
        cardsId: num,
        status: "markAsActive",
      };
  
      await updateTimeCardsRequest(user.id, keys);
      getSummaryDetails(offset);
      setSelectedBoxes([]);
      setSelectAll(false);
      
    } catch (error) {
      console.error(error)
    }
  };

  let deleteCards = async () => {
    try {
      let checked = document.querySelectorAll("input:checked");
      let num = [];
      for (const item of checked) {
        num.push(parseInt(item.id));
        item.checked = false;
      }
  
      let timecards = {
        cardsId: num,
      };
  
      await deleteTimeCardsRequest(user.id, timecards)
      await getSummaryDetails(offset);
      setSelectedBoxes([]);
      setSelectAll(false);
      
    } catch (error) {
      console.error(error)
    }
  };

  /**
   * @async
   * @function getSummaryDetails
   * @param {number} offset 
   * @description - fetches and updates the daily summary data
   */
  const getSummaryDetails = async (offset) => {
    setLoading(true);
    const keys = {
      id: user.id,
      date: moment(selectedDate).format("YYYY-MM-DD"),
      offset,
    };
    let summary = await fetchSummaryData(keys);
    if (summary) {
      setSummary(summary);
    }else{
      setSummary([])
    }
    setLoading(false);
    setLoadingImages(false);
  };
  /**
   * @async
   * @function fetchSummaryData
   * @param {string} keys    
   */
  const fetchSummaryData = async (keys) => {
    try {
      const response = await getUserDiaryRequest(keys.id, keys.date, keys.offset);
      return response;
    } catch (error) {
      console.error("Error fetching summary data:", error);
      return undefined;
    }
  };
  /**
   * @function handleSelection
   * @param {boolean} state 
   * @param {number} id 
   * @description - handles individual checkbox selection
   */
  const handleSelection = (state, id) => {
    setSelectedBoxes((prevSelectedBoxes) => {
      const updatedSelectedBoxes = state
        ? [...prevSelectedBoxes, id]
        : prevSelectedBoxes.filter((boxId) => boxId !== id);

      setIsManuallySelected(true);

      if (
        updatedSelectedBoxes.length ===
        document.querySelectorAll(".cards-checkboxes").length
      ) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }

      return updatedSelectedBoxes;
    });
  };

  let user = getSessionItem("User");

  const faqDialogFooter = (
    <div>
        <Button label="Ok" icon="pi pi-check" onClick={() => setFaqVisible(false)} autoFocus />
    </div>
  )

  const faqDialogHeader = (
    <h4>Diary FAQ</h4>
  )

  useEffect(() => {
    if (isManuallySelected) return;

    const checkboxes = document.querySelectorAll(".cards-checkboxes");
    if (selectAll) {
      checkboxes.forEach((checkbox) => {
        checkbox.checked = true;
      });
      setSelectedBoxes(Array.from(checkboxes).map((checkbox) => checkbox.id));
    } else {
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
      setSelectedBoxes([]);
    }
  }, [selectAll, isManuallySelected]);

  const handleLoadDiary = async() => {
    getSummaryDetails(offset)
  } 

  let changeTimeOffset = (offset) => {
    let stg = offset.value.split(' ')
    setTimezone(offset.value)
    setOffset(stg[1])
    getSummaryDetails(stg[1]);
  };

  const handleJoyrideCallback = (data) => {
    const { action, index, type } = data;

    if (
      type === "step:after" &&
      action === "next" &&
      index === steps.length - 1
    ) {
      goToNextPage();
    }
  };

  const steps= [
    {
      content: 'Here you can find your timecards. You can manage those timecards in this section as well.',
      title: "Diary Page",
      placement: "center",
      target: 'body'
    },
    {
      content: "Use these filters to load your diary for a specific day and timezone. Select the date and click 'Load' to display your timecards.",
      placement: "top",
      target: ".step-0",
      title: "Filters"
    },
    {
      title: "Timecard Actions",
      content:
        "Once your timecards are loaded, you can select them and use the action buttons to delete cards or mark idle cards as active if they were incorrectly flagged.",
      placement: "center",
      target: "body",
    },
    {
      content: 'Click here if you need help understanding how timecards work. The FAQ explains why screenshots are taken and why some timecards may appear as idle.',
      placement: "left",
      target: "#diary-faq",
      title: "Diary FAQ",
      spotlightClicks: true
    },
  ]
  return (
    <div className="diary">
      <Toast ref={toast} position="top-center"/>
      <div>
        <Joyride
          steps={steps}
          run={runTour}
          continuous
          showSkipButton
          showProgress
          scrollToFirstStep
          callback={handleJoyrideCallback}
          locale={{
            next: "Next",
            last: "Next Page",
            skip: "Skip tour",
            back: "Back"
          }}
          styles={{
            options: {
              primaryColor: "#0BADDE",
              zIndex: 10000
            },
            tooltip: {
              borderRadius: "8px"
            },
            buttonNext: {
              backgroundColor: "#0BADDE"
            }
          }}
        />
        <div className="my-dashboard-header">
            <SubHeaderLinks />
        </div>
        <div className="page-header-title my-diary-title">
          <h1 className="user-requests-header">Diary</h1>
          <Button 
            id="diary-faq"
            icon="pi pi-exclamation-circle" 
            severity="warning"
            outlined
            className="page-header-title-requests-faq"
            onClick={() => setFaqVisible(true)}
          />
        </div>
        <div className="diaryMain step-0">
          <div className="filters">
            <div>
              <FloatLabel>
                <Calendar
                  value={selectedDate}
                  inputId="employee-diary-date-picker"
                  onChange={(e) => setSelectedDate(e.value)}
                  maxDate={new Date()}
                  placeholder="Select a date"
                  dateFormat="dd/mm/yy"
                />
                <label htmlFor="employee-diary-date-picker">Select a date</label>
              </FloatLabel>
            </div>
            <Dropdown 
              options={timezones}
              value={timezone}
              onChange={changeTimeOffset}
              optionLabel="label"
              optionValue="value"
              placeholder="Select a timezone"
              filter
              filterDelay={400}
              filterPlaceholder="Search by name"
              style={{width:"350px"}}
            />
            <Button label="Load" severity="info" onClick={handleLoadDiary} disabled={selectedDate === null}/>

            {loading && <LoadingSpinner />}
          </div>
          {!loadingImages && (
            <div className="diary-cards-box">
              
              {!user.disabled && summary.length > 0 && (
                <div className="timecard-action-box">
                  <Button 
                    label={selectedBoxes.length <= 0 ? "Select all" : "Clear selection"} 
                    icon={selectedBoxes.length <= 0 ? "pi pi-check" : "pi pi-times"}
                    severity="info" 
                    onClick={handleSelectAll}
                  />
                  <Button label="Timecard status" severity="warning" icon="pi pi-question-circle" onClick={() => setVisible(!visible)}/>
                  <div className="timecard-action-box">
                    <Can permission={PERMISSIONS.trackingUsersByIdCards_delete}>
                      <Button 
                        label="Delete time cards" 
                        severity="danger" 
                        icon="pi pi-trash" 
                        disabled={selectedBoxes.length <= 0} 
                        onClick={confirmDeleteDialog}
                      />
                    </Can>
                    
                    <Can permission={PERMISSIONS.trackingUsersByIdCards_put}>
                      <Button 
                        label="Mark as active" 
                        severity="success" 
                        icon="pi pi-plus-circle" 
                        disabled={selectedBoxes.length <= 0} 
                        onClick={confirmActivateDialog}
                      />

                    </Can>
                  </div> 
                  
                </div>
              )}
              <DiaryTimeLine handleSelection={handleSelection} data={summary} />
            </div>
          )}
        </div>
      </div>

      {/* TIME CARD STATUS DIALOG */}
      <Dialog
        header="Timecards Status"
        dismissableMask
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}
      >
        <div>
          <table className="timecard-dialog">
            <thead className="timecard-dialog">
              <tr className="timecard-dialog">
                <th className="timecard-dialog">Status</th>
                <th className="timecard-dialog">Description</th>
                <th className="timecard-dialog">Added to Payroll</th>
              </tr>
            </thead>
            <tbody className="timecard-dialog">
              <tr className="timecard-dialog">
                <td className="timecard-dialog">Idle</td>
                <td className="timecard-dialog">
                  Idle timecard is when the tracker did not identify any
                  activity.
                </td>
                <td className="timecard-dialog">No</td>
              </tr>
              <tr className="timecard-dialog">
                <td className="timecard-dialog">Productive</td>
                <td className="timecard-dialog">
                  A productive and valid timecard
                </td>
                <td className="timecard-dialog">Yes</td>
              </tr>
              <tr className="timecard-dialog">
                <td className="timecard-dialog">Manual Time</td>
                <td className="timecard-dialog">
                  A timecard created after MT was approved
                </td>
                <td className="timecard-dialog">Yes</td>
              </tr>
              <tr className="timecard-dialog">
                <td className="timecard-dialog">Marked</td>
                <td className="timecard-dialog">
                  An idle timecard marked as not idle by the user. Example: the
                  user was in a meeting or watching a training.
                </td>
                <td className="timecard-dialog">Yes</td>
              </tr>
              <tr className="timecard-dialog">
                <td className="timecard-dialog">Rejected</td>
                <td className="timecard-dialog">
                  A timecard that has been rejected by the manager{" "}
                </td>
                <td className="timecard-dialog">No</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="time-cards-status-table-close-btn">
          <Button label="Ok" severity="info" onClick={() => setVisible(!visible)}/>
        </div>

      </Dialog>

      {/* FAQ DIALOG */}
      <Dialog 
        className="request-faq-dialog"
        dismissableMask
        visible={faqVisible}
        header={faqDialogHeader} 
        footer={faqDialogFooter} 
        onHide={() => {if (!faqVisible) return; setFaqVisible(false); }}
      >
        <Accordion activeIndex={0}>
          <AccordionTab header="Why does the Tracker take photos of me?">
            <p>
              This is to safeguard you, in the event the client escalates stating that the agent is not taking calls or responding to tickets we can use this to prove work was being done.
            </p>
          </AccordionTab>
          <AccordionTab header="My Time Cards display as being idle?">
            <p>
              If the tracker identifies low activity the timecards are marked as Idle. If you are watching a training or in a meeting this is a false positive.
              To fix these cases navigate to your diary in the Wisdom dashboard, select the idle cards and make them active.
            </p>
          </AccordionTab>
        </Accordion>
      </Dialog>
    </div>
  );
}

export default Diary;
